import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms/forms';

@Component({
  selector: 'app-editable-field',
  templateUrl: './editable-field.component.html',
})
export class EditableFieldComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() tooltipTitle = '';
  @Input() required: boolean = false;
  @Input() validateMessage: any = null;
  @Input() form!: FormGroup;
  @Input() urlAutocomplete!: string;
  @Input() fieldName!: string;
  @Input() key!: string;
  @Input() allowActions: boolean = false;
  @Input() isEditing = false;
  @Input() originalValue: string = '';
  @Input() searchFor: 'nome' | 'descricao' | 'codigo' | 'nomeOuCodigo' = 'nome';

  @Output() onFocusOut = new EventEmitter<void>();
  @Output() onErrorsValidate = new EventEmitter<string>();
  @Output() event = new EventEmitter<{ confirm: boolean; data: any }>();

  onEdit() {
    if (this.form.get(this.name)) {
      this.form.get(this.name).enable();
      this.isEditing = true;
    }
  }

  onCancel() {
    if (this.form.get(this.name)) {
      this.event.emit({ confirm: false, data: null });
      this.form.get(this.name).setValue(this.originalValue);
      this.form.get(this.name).disable();
      this.isEditing = false;
    }
  }

  onSave() {
    if (this.form.get(this.name)) {
      this.event.emit({ confirm: true, data: this.originalValue });
      this.form.get(this.name).disable();
      this.isEditing = false;
    }
  }

  updateErrors() {
    this.onFocusOut.emit();
  }

  setErrorValidate() {
    this.onErrorsValidate.emit(this.name);
  }
}
